import styled from "styled-components";
export const InputAXS = styled.div<{ width?: number }>`
  font-family: "Open Sans", sans-serif;
  height: 54px;
  background: #f5f5f5;
  border-radius: 8px;
  outline: none;
  font-weight: 400;
  font-size: 14px;
  position: relative;
  margin-bottom: 30px;
  color: #9e9e9e;
  width: 100%;

  & > span {
    color: #bc0000;
  }

  input {
    width: 100%;
    border: 0px solid #e0e0e0;
    border-radius: 8px;
    outline: none;
    color: #757575;
    padding-left: 10px;
  }

  input:focus {
    border: 1px solid #6c5af4;
  }

  input::placeholder {
    color: transparent;
    padding-left: 20px;
  }

  label {
    pointer-events: none;
    position: absolute;
    top: calc(50% - 10px);
    left: 20px;
    transition: all 0.1s linear;
    -webkit-transition: all 0.1s linear;
    -moz-transition: all 0.1s linear;
    background-color: transparent;
    box-sizing: border-box;
    z-index: 1;
    padding-left: 10px;
  }

  input:required:valid {
    color: #000000;
    padding-left: 15px;
  }

  input:required:focus {
    color: #000000;
  }

  input:focus:required:invalid {
    border: 2px solid #615757;
  }

  input label {
    border: 2px solid #000000;
  }

  input:focus-within {
    color: #000000;
  }

  input:required:invalid + label:before {
    content: "";
  }

  input:focus + label,
  input:valid(:placeholder-shown) + label {
    top: 0;
  }

  input:focus + label,
  input:not(:placeholder-shown) + label {
    top: -10px;
    left: 15px;
    padding-left: 0px;
  }
`;
